var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3816_112792",
    style: {
      maskType: "luminance"
    },
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H20.5V20H0.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3816_112792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 3.78906H2.64844C1.78547 3.78906 1.08594 4.48859 1.08594 5.35156V17.8516C1.08594 18.7145 1.78547 19.4141 2.64844 19.4141H15.1484C16.0114 19.4141 16.7109 18.7145 16.7109 17.8516V9.25781",
    stroke: "#FC686F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6859 3.02477L10.8471 11.8636L8.08496 12.416L8.63738 9.65387L17.4762 0.81504C17.7813 0.509962 18.276 0.509962 18.5811 0.81504L19.6859 1.91992C19.991 2.225 19.991 2.71965 19.6859 3.02477Z",
    stroke: "#FC686F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3701 1.91922L18.5798 4.12891",
    stroke: "#FC686F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPaperIcon);
export default __webpack_public_path__ + "static/media/edit-paper-icon.09a90820ff7bca1a7f69b1994ccc8628.svg";
export { ForwardRef as ReactComponent };